<template>
  <div>
    <Modal v-model="visible" title="请选择需要结算的数据" width="1400" :mask-closable="false" :footer-hide="true" :fullscreen="true">
      <div class="search-container">
        <div class="search-box" :class="{ close: !searchMore }">
          <div class="input-item" v-if="$units.superviseShowVal()">
            <span class="label">供应商类型</span>
            <RadioGroup v-model="formData.supplierType" @on-change="changeSupplierType">
              <Radio label="">全部</Radio>
              <Radio label="1">保司</Radio>
              <Radio label="2">通道</Radio>
            </RadioGroup>
          </div>

          <div class="input-item" v-if="formData.supplierType">
            <span class="label">供应商</span>
            <Select v-model="formData.supplierId" placeholder="请选择" filterable clearable transfer>
              <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">保险公司</span>
            <Select v-model="formData.companyCode" placeholder="请选择" filterable clearable transfer>
              <Option v-for="(bean, i) in companyList" :key="i" :value="bean.code">{{ bean.name }}</Option>
            </Select>
          </div>

          <div class="input-item select-two">
            <Select v-model="dateType" :transfer="true">
              <Option value="3">承保日期</Option>
              <Option value="1">投保日期</Option>
              <Option value="2">支付日期</Option>
              <Option value="7">生效日期</Option>
            </Select>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="date"
              @on-change="date = $event"
            ></DatePicker>
          </div>

          <div class="input-item">
            <span class="label">产品名称</span>
            <Select v-model="formData.productCode" clearable transfer filterable>
              <Option :value="item.productCode" v-for="(item, index) in productList" :key="index">{{ item.productCode }}/{{ item.productName }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">选择保/批单</span>
            <Select v-model="formData.isBill" clearable>
              <Option value="0">保单</Option>
              <Option value="1">批单</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">保单号</span>
            <Input type="text" v-model="formData.policyNo" clearable placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">批单号</span>
            <Input type="text" v-model="formData.billNo" clearable placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">保单状态</span>
            <Select v-model="formData.policyStatusList" clearable transfer multiple>
              <Option value="1">已承保</Option>
              <Option value="-1">已退保</Option>
              <Option value="0">已终止</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">机构</span>
            <Select v-model="formData.owerIds" multiple clearable filterable :max-tag-count="1" @on-change="changeOrg">
              <Option v-for="item in orgList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span slot="label" class="label">
              是否扣款记录<span class="tip-icon">?</span>
              <div class="pop-tip">
                <span>是否为退保等原因需扣除费用的扣款记录（不含批单扣减）</span>
                <div class="arrow"></div>
              </div>
            </span>

            <RadioGroup v-model="formData.isDeduct" @on-change="searchAjax">
              <Radio label="">全部</Radio>
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="btn-item btn-box">
          <Button type="primary" @click="searchAjax">查询</Button>
          <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >条，共<span>{{ total }}</span
            >条数据</span
          >
        </div>
      </div>

      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange"> </Table>
      </div>
      <Page
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center; margin-top: 20px; margin-bottom: 50px"
      />
      <div class="footer-btn">
        <Button type="primary" @click="ok" :loading="loading" size="default">加入结算</Button>
        <Button @click="visible = false" size="default">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
export default {
  mixins: [pageTool, common],
  props: ['reportId'],
  data() {
    return {
      visible: false,
      loading: false,
      dateType: '7',
      date: [],
      formData: {
        isDeduct: '',
        supplierType: '',
        owerIds: [],
        sellType: []
      },
      productList: [],
      companyList: [],
      supplierList: [],
      // productThemeList: [],
      userList: [], //业务员
      total: null,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left'
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 160,
          render(h, params) {
            let billNo = params.row.billNo;
            return <span>{billNo ? billNo : '-'}</span>;
          },
          fixed: 'left'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '保单状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.policyStatus == 1) {
              return <span>已承保</span>;
            } else if (params.row.policyStatus == 0) {
              return <span>已终止</span>;
            } else if (params.row.policyStatus == 2) {
              return <span>续保</span>;
            } else if (params.row.policyStatus == -1) {
              return <span>已退保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用归属/机构',
          align: 'center',
          key: 'owerName',
          minWidth: 180
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'commissionType ',
          minWidth: 160,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if (commissionType == 1) {
              return <span>基础费用</span>;
            } else if (commissionType == 11) {
              return <span>限时加费活动</span>;
            }else if(commissionType == 13){
              return <span>梯度加费</span>;
            }
          },
        },
        {
          title: '净费率',
          align: 'center',
          key: 'netCommission',
          minWidth: 100,
          render(h, params) {
            const netCommission = params.row.netCommission;
            return <span>{netCommission ? netCommission + '%' : '-'}</span>;
          }
        },
        {
          title: '净收入',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            const netIncome = params.row.netIncome;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{netIncome ? netIncome : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{netIncome ? netIncome : '-'}</span>;
            }
          }
        },
        {
          title: '出单人',
          align: 'center',
          key: 'salesmanName',
          minWidth: 120
        },
        {
          title: '出单团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        }
      ],
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      loading: false,
      selectOrgIds: [],
      orgList: []
    };
  },
  methods: {
    async open(owerIds) {
      this.visible = true;
      this.isAll = false;
      this.loading = false;
      this.selectArr = [];
      this.formData.owerIds = [];
      this.formData.sellType = [];
      this.date = [];
      this.tableData = [];
      this.dateType = '7';
      this.$set(this, 'selectOrgIds', owerIds);
      await this.getOrgList(owerIds);
      this.getSupplier();
      this.queryProduct();
      this.getBaosi();
      this.getUserList(owerIds);
      this.searchAjax();
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 重置
    resetSearch() {
      this.formData = {};
      this.date = [];
      this.dateType = '7';
      this.formData.isDeduct = '';
      this.formData.supplierType = '';
      this.formData.owerIds = [];
      this.formData.sellType = [];
      this.formData.owerIds = this.selectOrgIds;
      this.searchAjax();
    },
    parameter() {
      let data = JSON.parse(JSON.stringify(this.formData));
      if (!data.owerIds.length) {
        data.owerIds = this.selectOrgIds;
      }
      if (this.date && this.date[0]) {
        if (this.dateType == 1) {
          //投保日期
          data.holdTimeStart = this.date[0];
          data.holdTimeEnd = this.date[1];
        } else if (this.dateType == 2) {
          //支付日期
          data.payTimeStart = this.date[0];
          data.payTimeEnd = this.date[1];
        } else if (this.dateType == 3) {
          //承保日期
          data.insureTimeStart = this.date[0];
          data.insureTimeEnd = this.date[1];
        } else if (this.dateType == 7) {
          //生效日期
          data.effectTimeStart = this.date[0];
          data.effectTimeEnd = this.date[1];
        }
      }
      return data;
    },
    // 获取列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/queryOrgNeedSettle',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: '2',
          ...this.parameter(),
          sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
    ok() {
      if (!this.isAll && this.selectArr.length == 0) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }
      let params = {};
      if (this.isAll) {
        params = {
          reportId: this.reportId,
          isAll: 1,
          commissionLogNeedSettleDTOList: this.selectArr,
          commissionLogNeedQuery: {
            ...this.parameter(),
            sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : '',
            type: '2'
          }
        };
      } else {
        params = {
          reportId: this.reportId,
          isAll: 0,
          commissionLogNeedSettleDTOList: this.selectArr
        };
      }
      this.loading = true;
      this.$http({
        url: '/buz/settlementData/saveData',
        type: 'POST',
        data: params
      }).then(res => {
        this.visible = false;
        this.$notice.success('加入结算成功');
        this.$emit('success');
        this.loading = false;
      });
    },
    // 获取供应商
    getSupplier() {
      this.$http({
        url: '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        this.supplierList = res.data;
      });
    },
    // 获取保司
    getBaosi() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        //赠险公司列表初始化
        this.companyList = res.data;
      });
    },
    // 产品
    queryProduct() {
      this.$http({
        url: '/buz/productBase/read/array',
        type: 'POST',
        data: {}
      }).then(res => {
        this.productList = res.data;
      });
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.formData.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all';
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list';
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then(res => {
          this.supplierList = res.data;
        });
      }
    },
    // 获取机构
    getOrgList(owerIds) {
      return this.$http({
        url: '/buz/organizationBase/queryList',
        type: 'POST',
        data: {
          ids: this.selectOrgIds
        }
      }).then(res => {
        this.orgList = res.data;
        this.$nextTick(() => {
          this.$set(this.formData, 'owerIds', owerIds);
        });
      });
    },
    // 获取当前机构业务员
    getUserList(owerIds = this.formData.owerIds) {
      this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: {
          orgaList: owerIds
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    changeOrg(data) {
      if (!data.length) {
        this.getUserList(this.selectOrgIds);
      } else {
        this.getUserList(data);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  position: relative;
  .search-box {
    margin-top: 20px;
    /deep/.select-two .ivu-select {
      width: 115px !important;
      min-width: 115px;
      .ivu-select-selection {
        border-right: 1px solid #dcdee2 !important;
      }
    }
    /deep/.date-picker {
      min-width: 190px;
    }
  }
  .btn-box {
    position: absolute;
    bottom: 13px !important;
    right: -10px;
  }
  .dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
    margin-right: 4px;
    vertical-align: top;
    transform: translateY(7px);
    &.red {
      background: #e3461f;
    }
    &.orange {
      background: #ff9900 !important;
    }
  }
}
/deep/ .ivu-icon-ios-close {
  color: #3c464f !important;
}
/deep/ .ivu-modal-body {
  padding-bottom: 30px !important;
}
.label {
  position: relative;
  .tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    bottom: -40px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -0px;
    padding: 3px 3px 3px 5px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 29px;
      transform: rotateZ(135deg);
    }
  }
}
/deep/.ivu-modal-close {
  top: 0px;
  font-size: 30px;
}
/deep/.ivu-modal-header {
  height: 45px;
  padding-left: 20px;
}
/deep/.ivu-modal-header-inner {
  font-size: 16px;
}
.footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
</style>
